// Convert an audiobook record into the shape PictureBook/StoryShelf expects,
// so Storybooks can render on the same shelves as Stories.

const audiobookToStory = (a) => {
  const status = a.status;
  const statusLower = String(status || "").toLowerCase();
  const isReady = statusLower === "ready" || statusLower === "completed";
  return {
    id: a.id,
    name: a.title || "Untitled Storybook",
    title: a.title || "Untitled Storybook",
    thumbnail_url: a.cover_url || a.cover_image_url || a.thumbnail_url || null,
    cover_image_url: a.cover_image_url || a.cover_url || a.thumbnail_url || null,
    // Trust backend status — ready books must not look "generating".
    file_url: isReady ? "ready" : null,
    status,
    status_percentage: isReady ? 100 : a.progress || a.percentage || 0,
    creation_method: a.creation_method,
  };
};

export default audiobookToStory;
export { audiobookToStory };
